import editTabsMixin from '../../mixins/editTabsMixin'
import { api } from '@/global/services/api'

const TAB_KEY = 'basicInfo'
const CONTACT_DATA_KEY = 'contacts'
const CONTACT_DISPLAY_PROPS = ['type_id', 'value']

export default {
  mixins: [
    editTabsMixin
  ],

  data () {
    return {
      basicInfoKey: TAB_KEY,
      contactTypes: []
    }
  },

  computed: {
    basicInfoEditConfig () {
      return {
        title: this.$t('base/user.basic_info'),
        key: TAB_KEY,
        onLoad: () => this.onBasicInfoTabLoad(),
        apiConfig: {
          get: {
            module: 'base',
            route: `user/${this.$route.params.id}/basic-info`
          },
          post: {
            module: 'base',
            route: `user/${this.$route.params.id}/basic-info`
          }
        },
        dataFetched: (event) => {
          this.showUserRolesTab = !event?.data?.data?.isMaster
        },
        modifyDataBeforeSend: (event) => this.modifyBasicInfoData(event),
        hiddenFormKeys: [
          CONTACT_DATA_KEY
        ],
        tabContent: [
          {
            component: this.tabActionsComponent,
            title: this.$t('fleet/vehicle.basic_info'),
            showBackButton: {
              onGoBack: () => this.goBack()
            }
          },
          {
            component: this.columnsContentComponent,
            rows: [
              {
                type: 'fields',
                columnsCount: 2,
                fields: [
                  {
                    key: 'first_name',
                    label: this.$t('base/user.first_name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'last_name',
                    label: this.$t('base/user.last_name'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'username',
                    label: this.$t('base/user.username'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'email',
                    label: this.$t('base/user.email'),
                    creatable: true,
                    editable: true,
                    visible: true
                  }
                ]
              }
            ]
          },
          {
            title: this.$t('base.user_contacts'),
            showButtons: false,
            component: this.dynamicColumnsContentComponent,
            key: CONTACT_DATA_KEY,
            display_props: CONTACT_DISPLAY_PROPS,
            headers: [this.$t('base/contact_type.type'), this.$t('base/contact_type.value')],
            fields: [
              {
                key: 'type_id',
                type: 'autocomplete',
                autocomplete_options: {
                  module: 'base',
                  route: 'contact-types/autocomplete',
                  fetchInitial: false
                },
                items: this.contactTypes,
                creatable: true,
                editable: true,
                visible: true
              },
              {
                key: 'value',
                creatable: true,
                editable: true,
                visible: true
              }
            ]
          }
        ]
      }
    }
  },

  methods: {
    async onBasicInfoTabLoad () {
      try {
        const { data } = await api('base').get('contact-types/autocomplete')
        const { type_id: contactTypes } = data || {}
        if (contactTypes?.length) {
          this.contactTypes = contactTypes
        }
      }
      catch (exception) {
        console.error(exception)
      }
    },

    modifyBasicInfoData (event) {
      const { copiedData } = event || {}

      if (copiedData?.[CONTACT_DATA_KEY]?.length) {
        copiedData[CONTACT_DATA_KEY] = copiedData[CONTACT_DATA_KEY].map(item => ({
          type_id: item?.type_id?.id || item?.type_id,
          value: item?.value
        }))
      }
      else {
        delete copiedData[CONTACT_DATA_KEY]
      }

      return copiedData
    }
  }
}
